export default "__VITE_ASSET__D2kwFK1o__"